<template lang="pug">

    modal(ref='modal' custom-width='420px' v-on:closed='onClosed')
        div(slot='header')
            i.key.icon
            | Sitzung abgelaufen
        div(slot='content')
            p Deine Sitzung ist abgelaufen. Bitte melde dich erneut an.
        div(slot='footer')
            .ui.buttons
                button.ui.button(v-on:click='goToLogin') Zur Loginseite
                button.ui.primary.button(v-on:click='relogin') Erneut anmelden

</template>

<script>
    import Modal from './Modal'
    import router from '@/router'
    import { sessionBus } from '@/utils/session'
    import { clear_session_storage } from '@/utils/http-error'

    export default {
        name: 'session-expired-modal',

        components: { Modal },

        data() {
            return {
                redirectTo: null,
                visible: false,
            }
        },

        created() {
            sessionBus.$on('session-expired', this.onSessionExpired)
        },

        beforeDestroy() {
            sessionBus.$off('session-expired', this.onSessionExpired)
        },

        methods: {

            onSessionExpired(redirectTo) {
                if (this.visible) return
                this.visible = true
                this.redirectTo = redirectTo || null
                this.$refs.modal.show()
            },

            relogin() {
                this.close()
                clear_session_storage()
                if (this.redirectTo) {
                    router.push({ name: 'app/login', query: { redirect: this.redirectTo } })
                } else {
                    router.push({ name: 'app/login' })
                }
            },

            goToLogin() {
                this.close()
                clear_session_storage()
                router.push({ name: 'app/login' })
            },

            close() {
                this.visible = false
                this.$refs.modal.close()
            },

            onClosed() {
                this.visible = false
            },

        },

    }

</script>
